import React, { useState, useRef , useEffect } from "react";
import { ReportsServe } from "../../services/api/ReportsServ";
import { useSelector} from 'react-redux';
// import { CSVLink } from "react-csv";
// import Papa from "papaparse";
import { Calendar } from "primereact/calendar"; 
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Chart } from "primereact/chart";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Toast } from "primereact/toast";
import moment from 'moment';
import "./Reports.css";

const Report = () => {
  // const [csvData, setCsvData] = useState([]);
  const isLogged = useSelector((state) => state.auth.isLogged);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [lpList, setLpList] = useState([]);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [totalChartData, settotalChartData] = useState({});
  const [totalChartOptions, settotalChartOptions] = useState({});
  const [publishedChartData, setPublishedChartData] = useState({});
  const [publishedChartOptions, setPublishedChartOptions] = useState({});
  // const [status, setStatus] = useState('');
  const toast = useRef(null);

  useEffect(()=>{
    if (isLogged) {
    setStartDate(new Date(moment().startOf('month')));
    setEndDate(new Date(moment().endOf('month')));
    // setStatus('all');
    getReport();
  }
},[])

  const createTotalPocChart = async (idTotal, netLineTotal, trendLineTotal) => {
    const documentStyle = getComputedStyle(document.documentElement);
    const data = {
      labels: ["ID-(Webinar,WhitePaper)", "NetLine", "ID-TrendLine"],
      datasets: [
        {
          data: [idTotal, netLineTotal, trendLineTotal],
          backgroundColor: [
            documentStyle.getPropertyValue("--purple-500"),
            documentStyle.getPropertyValue("--indigo-500"),
            documentStyle.getPropertyValue("--cyan-500"),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue("--purple-400"),
            documentStyle.getPropertyValue("--indigo-300"),
            documentStyle.getPropertyValue("--cyan-300"),
          ],
        },
      ],
    };

    const chartOpts = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
      },
    };
    settotalChartData(data);
    settotalChartOptions(chartOpts);
  };

  const createTotalPublishedPocChart = async (
    idTotal,
    netLineTotal,
    trendLineTotal
  ) => {
    const documentStyle = getComputedStyle(document.documentElement);
    const data = {
      labels: ["ID-(Webinar,WhitePaper)", "NetLine", "ID-TrendLine"],
      datasets: [
        {
          data: [idTotal, netLineTotal, trendLineTotal],
          backgroundColor: [
            documentStyle.getPropertyValue("--purple-500"),
            documentStyle.getPropertyValue("--indigo-500"),
            documentStyle.getPropertyValue("--cyan-500"),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue("--purple-400"),
            documentStyle.getPropertyValue("--indigo-300"),
            documentStyle.getPropertyValue("--cyan-300"),
          ],
        },
      ],
    };

    const chartOpts = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
      },
    };
    setPublishedChartData(data);
    setPublishedChartOptions(chartOpts);
  };

  const handleSubmit = () => {
    if (!startDate || !endDate) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Both start date and end date are required.",
        life: 3000,
      });
    } else if (new Date(endDate) < new Date(startDate)) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "End date should be after the start date.",
        life: 3000,
      });
    } else {
      getReport();
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Report Generated Successfully",
        life: 3000,
      });
    }
  };

  const getReport = async () => {
    try {
      let payload = {
        startDate: startDate,
        endDate: endDate,
        // status : status
      };
      let data = await ReportsServe.getReport(payload);
      setLpList(data);
      getLPCount(data);
      // const csv = Papa.unparse(data);
      // setCsvData(csv);
    } catch (error) {
      console.log(error);
    }
  };

  const getLPCount = async (data) => {
    let ID = data.filter(
      (ele) => ele["templateNo"] === null || ele["templateNo"] === 0
    );
    let netLine = data.filter((ele) => ele["templateNo"] === 1);
    let trendLine = data.filter((ele) => ele["templateNo"] === 2);
    let IDPublished = ID.filter((ele) => ele["status"] === "published");
    let netLinePublished = netLine.filter(
      (ele) => ele["status"] === "published"
    );
    let trendLinePublished = trendLine.filter(
      (ele) => ele["status"] === "published"
    );
    console.log(ID.length, netLine.length, trendLine.length);
    createTotalPocChart(ID.length, netLine.length, trendLine.length);
    createTotalPublishedPocChart(
      IDPublished.length,
      netLinePublished.length,
      trendLinePublished.length
    );
  };

  const exportCSV = () => {
    const excelData = lpList.map((row) => ({
      Title: row.name,
      "Campaign Name": row.campaignName,
      "Campaign Id": row.campaignId,
      Description: row.description,
      "Asset Link": row.assetLink,
      Status: row.status,
      "Created By": row.createdBy,
      "Created At" : formatDate(row.createdAt),
      "Updated By": formattedUpdatedBy(row.updatedBy),
      "Category" : (!row.templateNo || row.templateNo === 0) ? 'ID-(Webinar,WhitePaper)' : ((row.templateNo === 1) ? 'NetLine' : 'ID-TrendLine')
    }));
    // Original file name with underscores 
    const originalFileName = `LP Report(${formatDate(new Date(startDate)) + "-" + formatDate(new Date(endDate))})`; 
    // Replacing underscores with slashes 
    const formattedFileName = originalFileName.replace(/_/g, '/');
    downloadData(excelData, formattedFileName);
  };

const formattedUpdatedBy = (data) => {
  if (!Array.isArray(data)) return "";

  return data
    .map((item) => item?.details?.name)
    .filter(Boolean)
    .join(", ");
};

  const downloadData = (data, fileName) => {
    // console.log(fileName);
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'LP Report');
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(dataBlob, fileName);
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
 
  const renderHeader = () => {
    return (
      <div
        className="flex table-search-btn"
      >
        <div>
          <Button
            type="button"
            icon="pi pi-download"
            rounded
            onClick={exportCSV}
            data-pr-tooltip="CSV"
          >
            {" "}
            <span className="lm-4">Download </span>
          </Button>
        </div>
        <div className="p-inputgroup w-450">
          <span className="p-inputgroup-addon">
            <i className="pi pi-search"></i>
          </span>
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search using Title,campaign Name, status..."
          />
        </div>
      </div>
    );
  };

 const renderUpdatedBy = (rowData) => {
  const updatedBy = rowData?.updatedBy || [];

  if (!Array.isArray(updatedBy) || updatedBy.length === 0) {
    return null;
  }

  return (
    <div>
      {updatedBy.map((item, index) => (
        <span key={index}>
          {item?.details?.name || ""}
          {index < updatedBy.length - 1 ? ", " : ""}
        </span>
      ))}
    </div>
  );
};

  const renderCategory = (rowData)=>{
    return (!rowData.templateNo || rowData.templateNo === 0) ? 'ID-(Webinar,WhitePaper)' : ((rowData.templateNo === 1) ? 'NetLine' : 'ID-TrendLine')
  }

 const renderDescription = (rowData) => {
  const description = rowData?.description || "";
  return description.length > 100
    ? description.slice(0, 80) + "..."
    : description;
};

const renderAssetLink = (rowData) => {
  const assetLink = rowData?.assetLink || "";
  return assetLink.length > 80
    ? assetLink.slice(0, 80) + "..."
    : assetLink;
};

const renderCampaignName = (rowData) => {
  const campaignName = rowData?.campaignName || "";
  return campaignName.length > 100
    ? campaignName.slice(0, 80) + "..."
    : campaignName;
};

const renderCampaignID = (rowData) => {
  const campaignId = String(rowData?.campaignId ?? "");
  return campaignId.length > 10
    ? campaignId.slice(0, 10) + "..."
    : campaignId;
};





  const formatDate = (value) => { 
    return new Intl.DateTimeFormat('en-GB', 
      { day: '2-digit',
         month: '2-digit', 
         year: 'numeric' }).format(new Date(value)) }; 
  const dateTemplate = (rowData) => { return formatDate(new Date(rowData.createdAt)); }
  const header = renderHeader();
  return (
    <>
      <Toast ref={toast} />
      {/* <div>
        <h1>Weekly / Monthly Report</h1>
      </div> */}

      <div style={{ width: "100%", maxWidth: "100vw", overflowX: "auto" }}
        className="card flex flex-wrap gap-6 p-fluid flex-direction-unset mt-5 justify-content-center"
      >
        <div className="flex-auto">
          <label htmlFor="buttondisplay" className="font-bold block mb-2">
            From Date
          </label>
          <Calendar
            id="buttondisplay"
            className="custom-datepicker"
            value={startDate}
            defaultValue={startDate}
            onChange={(e) => setStartDate(e.value)}
            showIcon
          />
        </div>
        <div className="flex-auto">
          <label htmlFor="buttondisplay" className="font-bold block mb-2">
            To Date
          </label>
          <Calendar
            id="buttondisplay"
            value={endDate}
            defaultValue={endDate}
            onChange={(e) => setEndDate(e.value)}
            showIcon
          />
        </div>
        <div className="flex-auto tp-25 col-center-align">
          <Button className="generate-report-btn"
            onClick={handleSubmit}
          >
            Generate Report
          </Button>
        </div>
      </div>

      {lpList.length > 0 && (
       <div className="report-table-container"> 
          <Card className="mt-3" style={{width: "100%", maxWidth: "100vw", overflowX: "auto" }}>
            <div className="row">
              <div className="md:col-6 sm:col-12 flex justify-content-center">
                <div className="chart-position">
                  <p className="chartTitle">All POCs</p>
                  <Chart
                    type="pie"
                    data={totalChartData}
                    options={totalChartOptions}
                    className="w-full md:10rem flex justify-content-center"
                  />
                </div>
              </div>
              <div className="md:col-6 sm:col-12 flex flex-wrap justify-content-center">
                <div className="chart-position">
                  <p className="chartTitle">Published POCs</p>
                  <Chart
                    type="doughnut"
                    data={publishedChartData}
                    options={publishedChartOptions}
                    className="w-full md:10rem flex justify-content-center"
                  />
                </div>
              </div>
            </div>
          </Card>

          <Card className="dt-styling">
         <div style={{ width: "100%", maxWidth: "100vw", overflowX: "auto" }}>

  <DataTable
    value={lpList}
    scrollable
    scrollHeight="494px"
    showGridlines
    paginator
    rows={10}
   tableStyle={{ minWidth: '50rem' }}
    filters={filters}
    header={header}
    emptyMessage="No POC's found."
  >
              <Column
                field="name"
                header="Title"
                headerClassName="custom-header"
                style={{ minWidth: "200px", fontSize:'14px'  }}
                frozen
              ></Column>
              <Column
                field="campaignName"
                header="Campaign Name"
                headerClassName="custom-header"
                body={renderCampaignName}
                style={{ minWidth: "200px" , fontSize:'14px' }}
              ></Column>
              <Column
                field="campaignId"
                header="Campaign ID"
                headerClassName="custom-header"
                body={renderCampaignID}
                style={{fontSize:'14px'}}
              ></Column>
              <Column
                field="description"
                header="Description"
                headerClassName="custom-header"
                body={renderDescription}
                style={{ minWidth: "300px", fontSize:'14px'  }}
              ></Column>
              <Column
                field="assetLink"
                header="Asset Link"
                headerClassName="custom-header"
                body={renderAssetLink}
                style={{ minWidth: "200px", fontSize:'14px' }}
              ></Column>
              <Column
                field="status"
                header="Status"
                headerClassName="custom-header"
                style={{fontSize:'14px'}}
              ></Column>
              <Column
                field="createdBy"
                header="Created By"
                headerClassName="custom-header"
                style={{ minWidth: "200px" , fontSize:'14px' }}
              ></Column>
               <Column
                field="createdAt"
                header="Created At"
                headerClassName="custom-header"
                body={dateTemplate}
                style={{ minWidth: "200px" , fontSize:'14px' }}
              ></Column>
              <Column
                field="updatedBy"
                header="Updated By"
                headerClassName="custom-header"
                style={{ minWidth: "200px" , fontSize:'14px' }}
                body={renderUpdatedBy}
              ></Column>
               <Column
                field="catergory"
                header="Category"
                headerClassName="custom-header"
                style={{ minWidth: "200px" , fontSize:'14px' }}
                body={renderCategory}
              ></Column>
             
            </DataTable>
         </div>
            
          </Card>
        </div>
      )}

      {lpList.length === 0 && (
        <Card className="mt-4">
          <div
            className="row justify-content-center align-items-center vh-65"
          >
            <p className="chartTitle">No Data Found...</p>
          </div>
        </Card>
      )}
    </>
  );
};

export default Report;
